import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles(theme => ({
  wrapper: {
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& > div': {
      width: 700,
      maxWidth: '100%',
      background: '#fff',
      padding: 20,
      maxHeight: '100%',
      overflow: 'auto',
    },
  },
  set: {
    textAlign: 'center',
    background: '#eee',
    borderRadius: '1em',
    marginBottom: 10,
    overflow: 'hidden',
    '& > div': {
      justifyContent: 'center',
      display: 'flex',
    },
    '& span': {
      display: 'block',
      textAlign: 'center',
      padding: '0.25em',
      width: '25%',
      cursor: 'pointer',
      borderLeft: '1px solid #666',
      '&:hover': {
        background: '#ddd',
      },
      '&:first-child': {
        borderLeft: 'none',
      },
    }
  },
  title: {
    textAlign: 'center',
    fontSize: '1.25em',
    color: theme.palette.primary.main,
  },
  sample: {
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.secondary.main,
  },
  action: {
    textAlign: 'center',
    verticalAlign: 'middle',
    marginTop: 20,
    '& button': {
      margin: '0 3px',
      verticalAlign: 'middle',
    },
    '& > span': {
      display: 'inline-block',
      minWidth: 53,
      verticalAlign: 'middle',
      userSelect: 'none',
    },
  },
  '@media(max-width: 850px)': {

  }
}));

function TheOther(props) {
  const classes = useStyles();
  const [ finished, setFinished ] = useState(false);
  const [ answered, setAnswered ] = useState([ false, false, false, false, false ]);
  const { exercise, startStats, finishExercise, action, type, close } = props.exerciseProps;

  useEffect(() => {
    startStats(type);
    // eslint-disable-next-line
  }, []);

  const checkWord = (wordNo, row, other) => {
    action();
    if(wordNo === other - 1) {
      correct(row);
    } else {
      incorrect();
    }
  }

  const correct = (row) => {
    const newAnswered = [ ...answered];
    newAnswered[row] = true;
    setAnswered(newAnswered);
    if (answered.reduce((sum, q) => q ? sum + 1 : sum, 0) === 4) {
      finish();
    } else {
      props.media.success();
    }
  }

  const incorrect = () => {
    props.media.failure();
  }

  const finish = () => {
    finishExercise();
    setFinished(true);
    props.media.finish();
  };

  return (
    <div className={classes.wrapper}>
      <div>
        <p className={classes.title}>Znajdź wyraz, który nie pasuje do pozostłych</p>
        {exercise.map((set, idx) => <div key={idx} className={classes.set}>
          {!answered[idx] && <div>
            <span onClick={() => checkWord(0, idx, set.other)}>{set.word1}</span>
            <span onClick={() => checkWord(1, idx, set.other)}>{set.word2}</span>
            <span onClick={() => checkWord(2, idx, set.other)}>{set.word3}</span>
            <span onClick={() => checkWord(3, idx, set.other)}>{set.word4}</span>
          </div>}
          {answered[idx] && <div>
            <span onClick={() => checkWord(0, idx, set.other)} style={{background: set.other === 1 ? '#ffc1c1': '#cbf5cb'}}>{set.word1}</span>
            <span onClick={() => checkWord(1, idx, set.other)} style={{background: set.other === 2 ? '#ffc1c1': '#cbf5cb'}}>{set.word2}</span>
            <span onClick={() => checkWord(2, idx, set.other)} style={{background: set.other === 3 ? '#ffc1c1': '#cbf5cb'}}>{set.word3}</span>
            <span onClick={() => checkWord(3, idx, set.other)} style={{background: set.other === 4 ? '#ffc1c1': '#cbf5cb'}}>{set.word4}</span>
          </div>}
        </div>)}
        {finished && <div className={classes.action}>
          <Button variant="outlined" color="secondary" onClick={close}>Zamknij</Button>
        </div>}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return { 
    media: state.media,
    mobile: state.mobile,
  }
}

export default connect(mapStateToProps)(TheOther);